import React from "react";
import foto from "../../images/Calendario Cigno 20232024.jpg"
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import sirene from "../../images/News/Sirene.jpg"
import TitoloSezioni from "../../commons/TitoloSezioni";
import calendario from "../../images/Calendario Cigno 20232024.jpg";
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";

function SireneNews () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <TitoloSezioni title={"Mermaid experience"} />
            <div className="container-foto-news m-auto" style={{display: "flex", flexDirection: "column"}}>
                <a style={{alignSelf: "end"}} href={sirene} download>
                    <i style={{fontSize: "2em", color: "grey", marginRight: "0.5em"}} className="bi bi-download"></i>
                </a>
                <img src={sirene} style={{width: "100%"}}></img>
            </div>
            <Space />

        </div>
    )
}
export default SireneNews